export const HelperFunctionBuiltin = [
  "#if",
  "#unless",
  "#each",
  "#with",
  "lookup",
  "log",
  "blockHelperMissing",
  "each",
  "helperMissing",
  "if",
  "unless",
  "log",
  "lookup",
  "with",
]

/**
 * full list of supported helpers can be found here:
 * https://github.com/Budibase/handlebars-helpers
 */
export const EXTERNAL_FUNCTION_COLLECTIONS = [
  "math",
  "array",
  "number",
  "url",
  "string",
  "comparison",
  "object",
  "regex",
  "uuid",
]

export const HelperFunctionNames = {
  OBJECT: "object",
  ALL: "all",
  LITERAL: "literal",
  JS: "js",
  DECODE_ID: "decodeId",
}

export const LITERAL_MARKER = "%LITERAL%"
